import type React from 'react';
import { type ReactNode, Fragment, isValidElement } from 'react';
import DotDivider from 'app/ui/components/atoms/dot-divider';

type DotDividedElementsWrapperProps = {
  elements: ReactNode[];
  color: string;
};

const DotDividedElementsWrapper: React.FC<DotDividedElementsWrapperProps> = ({ elements, color }) => {
  const dividedElements = elements.map((element) => (
    <Fragment key={isValidElement(element) ? element.key : null}>
      {element}
      {elements.length > 1 && <DotDivider color={color} />}
    </Fragment>
  ));

  return <>{dividedElements}</>;
};

export default DotDividedElementsWrapper;
